/** @format */
import { merge } from 'lodash';

import { toCamelCase } from '@toucan/common/helpers/change-case';

import {
    Market,
    MarketCode,
    defaultMarket,
} from '@toucan/client/global/market';

import { FilterQuery, Query, SelectedFilters, SortBy } from '../types';

export function getModelSearchResultsFacetsQuery(
    baseQuery: Partial<Query>,
    disallowedFilters: string[],
    selectedFilters: SelectedFilters,
    sort: SortBy,
    activeMarket: Market,
    outOfStock: boolean
) {
    const requiredFacets = [
        'model_brand',
        'model_category',
        'model_product_type',
        'product_condition_star_rating',
        'product_price',
    ].filter((facet) => !disallowedFilters.includes(toCamelCase(facet)));
    const searchFacets = [...requiredFacets, '*'];

    return getModelListingQuery(
        baseQuery,
        1,
        0,
        selectedFilters,
        sort,
        activeMarket.code,
        searchFacets,
        outOfStock
    );
}

export function getModelListingQuery(
    baseQuery: Query,
    start: number,
    rows: number,
    filterQuery: FilterQuery,
    sortBy: SortBy,
    market: MarketCode = defaultMarket.code,
    facetFields?: string[],
    // eslint-disable-next-line @typescript-eslint/no-inferrable-types -- Legacy code: do not use as an example.
    showOutOfStock: boolean = false
): Query {
    let query = merge({}, baseQuery, {
        fieldList: [
            'model_id',
            'model_name',
            'model_images',
            'product_price.minimum',
            'product_price.maximum',
            'product_price.count',
            'model_url_segment',
            'model_available_new',
        ],
        filterQuery: {
            modelMarket: market,
            objectType: 'model',
            modelAvailable: false,
            modelIsPublishedOut: true,
            ...filterQuery,
        },
        sort: sortBy,
        facetField: facetFields,
        start,
        rows,
    });

    if (!showOutOfStock) {
        query = merge(query, {
            filterQuery: {
                objectType: 'product',
                modelAvailable: true,
            },
            groupField: 'model_id',
        });
    }

    return query;
}
